/**
 * The top of every signed-in page: title, an optional line or two saying
 * what the page is for, and the page's primary actions on the right. Keeps
 * the title size, the lede's measure and the gap to the content identical
 * from page to page — see DESIGN.md "Page layout".
 *
 *   eyebrow  — optional evidence line above the title (e.g. a placement's type)
 *   title    — the h1
 *   lede     — optional; a string or a few <p>s, styled here
 *   actions  — optional buttons, right-aligned from `sm` up, stacked below on phones
 *   children — anything else that belongs in the header's left column
 *              (a filter note, a secondary line); rendered after the lede
 */
export const PageHeader = ({ eyebrow, title, lede, actions, children, titleTestId, className = '' }) => (
  <header className={`mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between ${className}`}>
    <div className="min-w-0">
      {eyebrow && <p className="pd-mono text-ink-55 mb-2">{eyebrow}</p>}
      <h1
        className="font-heading text-[34px] font-bold tracking-[-0.035em] leading-[1.05] text-ink"
        data-testid={titleTestId}
      >
        {title}
      </h1>
      {lede && <div className="mt-2 max-w-[65ch] space-y-2 text-base text-ink-70">{lede}</div>}
      {children}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2 sm:shrink-0">{actions}</div>}
  </header>
);

export default PageHeader;
